// Copyright (c) 2015, IntelOra Resources & Developments LLP
// License: see LICENSE

if (frappe.require) {
	frappe.require("file_uploader.bundle.js");
} else {
	frappe.ready(function () {
		frappe.require("file_uploader.bundle.js");
	});
}
